module.exports = __webpack_public_path__ + "static/oil-0bdd602efa469528ea9e6c816b4dfb3d.png";